/**
 * @generated SignedSource<<85989c584d0c28afecadd4356a69775c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RootCandidatesQuery$variables = {
  candidateCount: number;
  influencerId: string;
  postCount: number;
};
export type RootCandidatesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ApplyingsPagination" | "TodosPagination">;
};
export type RootCandidatesQuery = {
  response: RootCandidatesQuery$data;
  variables: RootCandidatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "candidateCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "influencerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postCount"
},
v3 = {
  "kind": "Variable",
  "name": "influencerId",
  "variableName": "influencerId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "candidateCount"
  },
  (v3/*: any*/)
],
v5 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "postCount"
  },
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentMediaType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Banner",
  "kind": "LinkedField",
  "name": "banners",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "file",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  "influencerId"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RootCandidatesQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "ApplyingsPagination"
      },
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "TodosPagination"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RootCandidatesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CandidateConnection",
        "kind": "LinkedField",
        "name": "applyings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Candidate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Campaign",
                    "kind": "LinkedField",
                    "name": "campaign",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SocialNetwork",
                        "kind": "LinkedField",
                        "name": "socialNetwork",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recruitmentEndOn",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "filters": (v14/*: any*/),
        "handle": "connection",
        "key": "ApplyingsList_applyings",
        "kind": "LinkedHandle",
        "name": "applyings"
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PostConnection",
        "kind": "LinkedField",
        "name": "posts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PostEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Post",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "draftedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Campaign",
                    "kind": "LinkedField",
                    "name": "campaign",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SocialNetwork",
                        "kind": "LinkedField",
                        "name": "socialNetwork",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "postStartOn",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "castEndAt",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "lastComment",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "action",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentReadTime",
                    "kind": "LinkedField",
                    "name": "influencerCommentReadTime",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "readableId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unreadCommentCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "filters": (v14/*: any*/),
        "handle": "connection",
        "key": "TodosList_posts",
        "kind": "LinkedHandle",
        "name": "posts"
      }
    ]
  },
  "params": {
    "cacheID": "45ca027b9e6f5c53b28f12f5647c665c",
    "id": null,
    "metadata": {},
    "name": "RootCandidatesQuery",
    "operationKind": "query",
    "text": "query RootCandidatesQuery(\n  $influencerId: ID!\n  $candidateCount: Int!\n  $postCount: Int!\n) {\n  ...ApplyingsPagination_1IkU69\n  ...TodosPagination_15DPat\n}\n\nfragment ApplyingCampaign on Candidate {\n  status\n  campaign {\n    id\n    status\n    parentMediaType\n    title\n    banners {\n      file\n      id\n    }\n    socialNetwork {\n      recruitmentEndOn\n      id\n    }\n  }\n}\n\nfragment ApplyingsPagination_1IkU69 on Query {\n  applyings(first: $candidateCount, influencerId: $influencerId) {\n    edges {\n      node {\n        id\n        ...ApplyingCampaign\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TodoCampaign on Post {\n  draftedAt\n  status\n  campaign {\n    parentMediaType\n    title\n    banners {\n      file\n      id\n    }\n    socialNetwork {\n      postStartOn\n      castEndAt\n      id\n    }\n    id\n  }\n}\n\nfragment TodoComments on Post {\n  lastComment {\n    content\n    action\n    id\n  }\n  influencerCommentReadTime {\n    id\n    readableId\n    unreadCommentCount\n  }\n}\n\nfragment TodosPagination_15DPat on Query {\n  posts(first: $postCount, influencerId: $influencerId) {\n    edges {\n      node {\n        id\n        status\n        ...TodoCampaign\n        ...TodoComments\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a8f7c8f3b51fed2b92f80547d4117f38";

export default node;
